import { TermsCopy } from '@components/ui';
import {
  AcceptanceSection,
  AdditionalTermsSection,
  AllTransactionsArbitrationSection,
  ArbitrationSection,
  BuyerConditionTable,
  GeneralTermsSection,
  OffSiteVehicleSalesSection,
  OnlineSalesArbitrationSection,
  OtherLegacyServicesSection,
  OtherOnlineAuctionSection,
  PriceBoostingSection,
  TermsOfServiceIntro,
} from '@features/legal/terms-and-conditions/terms-sections';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

interface TermConditionDialogProps {
  handleDialogBox: () => void;
}

const TermConditionDialog = ({
  handleDialogBox,
}: TermConditionDialogProps): JSX.Element => {
  const { t } = useTranslation();
  const handleClose = (): void => {
    handleDialogBox();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="terms-dialog-title" open>
      <DialogTitle id="terms-dialog-title" sx={{ pr: 7 }}>
        <TermsCopy i18nKey="termsSections.dialogTitle" />
      </DialogTitle>
      <IconButton
        aria-label={t('common.close')}
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TermsOfServiceIntro />
          </Grid>
          <Grid item xs={12}>
            <GeneralTermsSection />
            <ArbitrationSection />
            <AllTransactionsArbitrationSection titleKey="termsSections.allTransactionsArbitration.buyerTitle" />
            <OnlineSalesArbitrationSection />
            <AdditionalTermsSection />
          </Grid>
        </Grid>
        <BuyerConditionTable wide />
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <PriceBoostingSection />
            <OtherOnlineAuctionSection />
            <OffSiteVehicleSalesSection />
            <OtherLegacyServicesSection />
            <AcceptanceSection />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default TermConditionDialog;
